const getBusinessType = (list, type) => {
  const result = list.find((a) => a.code === type);
  return result ? result.name : "-";
};

export default getBusinessType;
